import React from 'react';
import { useNavigate } from 'react-router-dom'; // 👈 dodane
import familySmile from '../../images/osobowe.jpg';
import HeroSection from '../../components/HeroSection';
import OfertaCard from '../../components/OfertaCard';
import '../../style/ofertacard.css';

import PersonIcon from '@mui/icons-material/Person';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ElderlyIcon from '@mui/icons-material/Elderly';
import SchoolIcon from '@mui/icons-material/School';

const Osobowe = () => {
  const navigate = useNavigate(); // 👈 dodane

  const handleCardClick = () => {
    navigate('/kontakt'); // 👈 przekierowanie do kontaktu
  };

  const offerings = [
    {
      label: 'Ubezpieczenia zdrowotne',
      icon: <HealthAndSafetyIcon />,
      color: '#FF6B6B',
      description:
        'Zapewnia szybki dostęp do wysokiej jakości opieki medycznej, eliminując konieczność oczekiwania w kolejkach oraz umożliwiając korzystanie z prywatnych placówek zdrowotnych.',
    },
    {
      label: 'Ubezpieczenia na życie',
      icon: <PersonIcon />,
      color: '#4ECDC4',
      description:
        'Gwarantuje finansowe wsparcie dla Twoich bliskich w trudnych chwilach, zabezpieczając ich stabilność i przyszłość w przypadku Twojej śmierci.',
    },
    {
      label: 'Ubezpieczenia rodzinne',
      icon: <FamilyRestroomIcon />,
      color: '#FFD93D',
      description:
        'Kompleksowa ochrona wszystkich członków rodziny w ramach jednego pakietu, zapewniająca spokój i bezpieczeństwo każdego dnia.',
    },
    {
      label: 'Ubezpieczenia NNW',
      icon: <LocalHospitalIcon />,
      color: '#1A535C',
      description:
        'Zapewnia wsparcie finansowe i pomoc w razie nieszczęśliwego wypadku, pomagając pokryć koszty leczenia i rehabilitacji oraz rekompensując utratę dochodów.',
    },
    {
      label: 'Ubezpieczenia seniorów',
      icon: <ElderlyIcon />,
      color: '#FF6F91',
      description:
        'Specjalnie zaprojektowane dla osób starszych, oferujące ochronę zdrowia oraz dodatkowe wsparcie, które daje poczucie bezpieczeństwa i komfortu w codziennym życiu.',
    },
    {
      label: 'Ubezpieczenia edukacyjne',
      icon: <SchoolIcon />,
      color: '#34675C',
      description:
        'Pozwala na systematyczne oszczędzanie oraz zabezpieczenie finansowe, by zapewnić dziecku spokojną i bezpieczną przyszłość edukacyjną.',
    },
  ];

  return (
    <>
      <HeroSection image={familySmile} text="Ubezpieczenia osobowe – bo Twoje zdrowie ma znaczenie" />

      <section style={{ maxWidth: '1100px', margin: '2rem auto', padding: '0 1rem' }}>
        <h2>Ubezpieczenia osobowe</h2>
        <p>
          Ubezpieczenia osobowe chronią życie, zdrowie i bezpieczeństwo Twoje oraz Twojej rodziny.
          Oferujemy różnorodne rozwiązania dostosowane do indywidualnych potrzeb.
        </p>

        <div
          className="oferta-buttons"
          style={{ justifyContent: 'center', marginTop: '2rem', gap: '1.8rem' }}
        >
          {offerings.map(({ label, icon, color, description }) => (
            <OfertaCard
              key={label}
              label={label}
              icon={icon}
              color={color}
              description={description}
              onClick={handleCardClick} // 👈 przekazane do karty
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Osobowe;
